/*jshint browser: true */
/*global require: false, ga: false */

require(['jquery', 'core'], function ($) {
    'use strict';

    $(document).ready(function () {
        var hasAnchorTag = window.location.hash;
        if (hasAnchorTag.toLowerCase() == "serologyfaq") {
            // code
            $('#serologyfaq').toggleClass("toggle-header on");
        }
    });

    function sendRequest(rating, comment) {
        /*gtag('send', 'pageview', location.pathname + '/vote');*/

        $.ajax({
            url: '/api/feedback/Post/',
            type: 'POST',
            data: {
                Page: window.location.pathname,
                Vote: rating,
                Comment: comment
            },
            success: displayThanks,
            error: displayError
        });

        return false;
    }

    function displayThanks() {
        $('.form-feedback-thanks').removeClass('hide');
        $('.form-feedback-comment').addClass('hide');
        $('.form-feedback-buttons').addClass('hide');
        $('.form-feedback-error').addClass('hide');
    }

    function displayError() {
        $('.form-feedback-error').removeClass('hide');
    }

    $('.form-feedback').on('submit, click', function (e) {
        if (e.target.value && e.target.value === '-1') {
            $('.form-feedback-comment').removeClass('hide');
            $('.form-feedback-buttons').addClass('hide');
        } else if (e.target.value && e.target.value === '1') {
            sendRequest(e.target.value, '');
        }

        return false;
    });

    $('.form-feedback-comment button[type="submit"]').on('click', function () {
        sendRequest(-1, $('[name="comment"]').val());
    });
});
define("feedback", function(){});

